module.exports = __webpack_public_path__ + "img/1522312796.94c74ca9.jpg";